import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'


import imgHero from '../../images/hero_img_ai.png'
import imgSectionOne from '../../images/img_ai_01.png'
import imgSectionTwo from '../../images/img_ai_02.png'
import imgSectionThree from '../../images/img_ai_03.png'
import imgSectionFour from '../../images/img_ai_04.png'
import imgSectionFive from '../../images/img_ai_05.png'
import imgSectionSix from '../../images/img_ai_06.png'
import imgRoundedLeftTop from '../../images/rounded_left_top.png'
import imgRoundedLeftBottom from '../../images/circular_rounded_left.png'

import bindAll from 'lodash/bindAll'
import { accesslog, translate } from '../../helpers/global'

import { usersGetDetailAsync } from '../../actions/users.js'
import { props } from 'bluebird'
import { getWeeklyDemoDataAsync } from '../../actions/global';


class AIInterview extends React.Component<props> {

  	constructor(props) {
		super(props)
  }


	async componentDidMount() {
		window.scrollTo(0, 0)
    if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.webinar_link) {
      await this.props.getWeeklyDemoDataAsync();
    }
	}

  

  render() {
    const {
      globalGetLanguages,
      user, weeklyDemoData
    } = this.props
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="banner ai">
          <section>
            <div className="ban-text ai">
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'AI_INTERVIEW_BANNER_TITLE_1'))}</div>
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'AI_INTERVIEW_BANNER_TITLE_2'))}</div>
              <div className="title-1">{renderHTML(translate(globalGetLanguages,'AI_INTERVIEW_BANNER_TITLE_3'))}</div>
              

              <div className='content-desc'>
                {renderHTML(translate(globalGetLanguages,'AI_INTERVIEW_BANNER_TEXT'))}
              </div>

              <div className={`ban-link`}>
                <Link to={{pathname: `/register`, query: { plan: 'free' }}} className="try"
                  onClick={() => accesslog('ai-structured-video-interview', 'button_register', {title:'Start Your Free Plan'})}
                >{translate(globalGetLanguages,'BUTTON_START_FREE_PLAN')}</Link>
                <a onClick={() => {
                  accesslog('ai-structured-video-interview', 'button_talk_to_an_expert');
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                }} className="request-demo-logged">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</a>
              </div>
              <div className={`ban-link hide`}>
                <a onClick={() => {
                  accesslog('ai-structured-video-interview', 'button_talk_to_an_expert');
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                }} className="request-demo-logged">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</a>
              </div>
              <a href="#" className="vid-msg">
                <img src={imgHero} />
              </a>
            </div>
          </section>
        </div>

        <a href="#" className="vid-msg-left-top">
          <img src={imgRoundedLeftTop} />
        </a>

        <section class="container-title">
            Built to Make Hiring Faster, Easier <br />and More Accurate
        </section>

  

      <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container position-relative'>
            <div className='flex-item-left'>
              <div className='vertical-item--center' style={{ margin: '0 50px 0 0' }}>
                <img className='img-100' src={imgSectionOne} />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                {renderHTML(translate(globalGetLanguages,'TEXT_AI_TITLE_1'))}
                  </h2>
                  <p className='m-b-30'>Give candidates a smooth and flexible experience. <br />ASTRNT interviews can be taken from any device, with any <br />connection. Start on a phone, continue on a laptop—no <br />logins or downloads required.</p>
                  <p className='m-b-5'>{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_1_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_1_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_1_SUB_3'))}</li>
                  </ul>
                </div>
              </div>
            </div> 
          </section>
      </div>

      <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-left' style={{ zIndex: '1' }}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionTwo} />
              </div>
            </div>
            
            <div className='flex-item-right' style={{ zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                {renderHTML(translate(globalGetLanguages,'TEXT_AI_TITLE_2'))}
                  </h2>
                  <p className='m-b-30'>Remove inconsistency from early interviews. <br />Use role-based templates with standardised questions <br />and timing, so all candidates follow the same process.</p>
                  <p className='m-b-5'>{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_2_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_2_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_2_SUB_3'))}</li>
                  </ul>
                </div>
              </div>
            </div> 
          </section>
        </div>

        <div className="section-white" style={{position: 'relative'}}>
          <section className='flex-container'>
          
            <div className='flex-item-right' style={{ zIndex: '1'}}>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                {renderHTML(translate(globalGetLanguages,'TEXT_AI_TITLE_3'))} 
                  </h2>
                  <p className='m-b-30'>{renderHTML(translate(globalGetLanguages,'TEXT_AI_DESC_3'))}</p>
                  <p className='m-b-5'>{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_3_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_3_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_3_SUB_3'))}</li>
                  </ul>
                </div>
              </div>
            </div> 

            <div className='flex-item-right' style={{ zIndex: '1'}}>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionThree} />
              </div>
            </div>
            <img className="rounded-circular-left" src={imgRoundedLeftBottom} />
          </section>
      </div>
      <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                {renderHTML(translate(globalGetLanguages,'TEXT_AI_TITLE_4'))}
                  </h2>
                  <p className='m-b-30'>{renderHTML(translate(globalGetLanguages,'TEXT_AI_DESC_4'))}</p>
                  <p className='m-b-5'>{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_4_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_4_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_4_SUB_3'))}</li>
                  </ul>
                </div>
              </div>
            </div> 

            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionFour} />
              </div>
            </div>

          </section>
      </div>
      <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
                      
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}> 
                {renderHTML(translate(globalGetLanguages,'TEXT_AI_TITLE_5'))}
                  </h2>
                  <p className='m-b-30'>{renderHTML(translate(globalGetLanguages,'TEXT_AI_DESC_5'))}</p>
                  <p className='m-b-5'>{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES'))}</p>
                  <ul>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_5_SUB_1'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_5_SUB_2'))}</li>
                    <li><i className="fas fa-check" />{renderHTML(translate(globalGetLanguages,'TEXT_AI_FEAURES_5_SUB_3'))}</li>
                  </ul>
                </div>
              </div>
            </div> 

            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionFive} />
              </div>
            </div>

          </section>
      </div>

      <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionSix}/>
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                {renderHTML(translate(globalGetLanguages,'TEXT_AI_TITLE_6'))}
                  </h2>
                  <p className='m-b-24'>{renderHTML(translate(globalGetLanguages,'TEXT_AI_DESC_6'))}</p>                 
                </div>
              </div>
            </div> 
          </section>
      </div>


      <div className="section-gray single-triangle triangle-right" style={{position: 'relative'}}>
          <section className='p-t-50 p-b-50'>
            <div className='ai-interview-start'>
              <h1>Ready to Screen, Select & Hire Smarter?</h1>
              <h4>Replace screening calls with structured, AI-powered video interviews that are scalable and consistent—without<br />compromising candidate experience.</h4>
                <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <Link to={{pathname: `/register`, query: { plan: 'free' }}} className="try"
                    onClick={() => accesslog('ai-structured-video-interview', 'button_register', {title:'Start Your Free Plan'})}
                  >{translate(globalGetLanguages,'BUTTON_START_FREE_PLAN')}</Link>
                  <a onClick={() => {
                    accesslog('ai-structured-video-interview', 'button_talk_to_an_expert');
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  }} className="request-demo-logged">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</a>
                </div>
                <a className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                  href={weeklyDemoData.webinar_link} target='_blank'
                  onClick={() => accesslog('ai-structured-video-interview', 'button_register_for_demo', {title: weeklyDemoData.title})}  
                > Register for Demo </a>
              </div>

            </div>
          </section>
        </div>

        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData 

	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user)),
    getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AIInterview)
